<template>
  <tbody :class="{'is-rowMoreInformations-visible': isRowLotOpen}"> <!-- HB : la balise 'tbody' ne doit pas être ici les 'tr' doivent être les un apres les autres  -->
    <tr class="is-size-6 table-rowMain" :class="{'tr--draft': lot.status === 'draft', 'is-rowMoreInformations-visible': isRowLotOpen}">
      <td class="has-text-centered is-paddingless">
        <span v-if="!multiselection" class="dot tooltip is-tooltip-right"
              :class="lot.status|dotClass" :data-tooltip="lot.status|statusLabel"></span>
        <multiselect-button v-else
                            :data="lot"
                            :is-checked="checkedItem(lot.pk)"
                            :multiselection="multiselection"
                            @selected="v => $emit('selectItem', v)">
        </multiselect-button>
      </td>
      <td class="is-narrow is-paddingless has-toggle-rowMoreInformations">
        <div class="">
          <router-link class="is-padding-right-small is-padding-left-xsmall is-height-full columns is-vcentered is-cell-hoverable" :to="{name: 'LotVue', params: {id: lot.pk}, query: {returnId: lot.pk, page: currentPage}}">
            <!-- <b>{{lot.ref || '-' | truncateShort}}</b> -->
            <b>{{lot.ref || '-'}}</b>
          </router-link>
          <a class="has-toggle-rowMoreInformations-toggle is-border-left is-height-full columns is-vcentered is-cell-hoverable"
            @click="toggleRowLot" :class="{'has-bg-black has-text-white': isRowLotOpen}"
            v-if="!rowIsParking">
            <div class="is-padding-small tooltip is-tooltip-right"
              :data-tooltip="'Détails'"
            >
              <span class="icon">
                <i v-if="isRowLotOpen && !loadingRowLot" class="fal fa-times"></i>
                <i v-else-if="isRowLotOpen && loadingRowLot" class="fas fa-spinner fa-spin"></i>
                <i v-else class="fas fa-chevron-down"></i>
              </span>
            </div>
          </a>
          <div v-else class="has-toggle-rowMoreInformations-toggle is-height-full is-border-left">
            <div class="is-padding-small"><span class="icon"></span></div>
          </div>
        </div>
      </td>
      <router-link class="is-cell-hoverable is-narrow" :to="{name: 'ProgramVue', params: {id: lot.program}, query: {returnId: lot.pk, page: currentPage}}" tag="td" v-if="showColumn('program')">
        <a :title="lot.program_name">
          <span class="is-size-6 has-text-grey">
            {{lot.program_name | truncate(22)}}
            <span class="icon has-text-grey tooltip is-tooltip-top"
                  data-tooltip="Flux promoteur" v-if="isDistributeurMode && lot.from_flux && !isExternal">
              <i class="fas fa-rss"></i>
            </span>
          </span>
        </a>
      </router-link>
      <td v-if="isDistributeurMode && showColumn('promoteur_name') && !isExternal" class="is-cell-hoverable">
        <router-link :to="{name:'PromoteurVue', params: {id: lot.promoteur}, query: {returnId: lot.pk, page: currentPage}}" :title="lot.promoteur_name" v-if="isAdmin || isEditor">
          {{lot.promoteur_name | truncate}}
        </router-link>
        <span v-else>{{lot.promoteur_name | truncate}}</span>
      </td>
      <td :class="{'has-cursor-pointer' : !rowIsParking}" v-if="showColumn('zip_code')" @click="toggleRowLot">
        <span v-if="lot.address && lot.address.zip_code">
          {{lot.address.zip_code || ''}}
        </span>
        <span v-else>-</span>
      </td>
      <td class="is-nowrap" v-if="showColumn('city')" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.address && lot.address.city">
          {{lot.address.city| truncate}}
        </span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('nature')" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="isParking">Parking/Box/Garage</span>
        <span v-else-if="lot.nature">{{natureLabel(lot.nature)}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="!isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.lot_type">{{lotTypeLabel(lot.lot_type)}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('surface') && !isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.surface">{{lot.surface|prettyPrice}} m²</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('floor') && !isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.floor">{{lot.floor}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('exposures') && !isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.exposures && lot.exposures.length">{{lot.exposures | exposuresShortLabel}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('parking') && !isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.parking_count">{{lot.parking_count}}</span>
        <span v-else>-</span>
      </td>
      <td @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.sale_price">{{lot.sale_price | prettyPrice}} {{$currency}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('rent') && !isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.rent">{{lot.rent | prettyPrice}} {{$currency}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('tax_dispositifs') && !isParking" class="is-narrow has-cursor-pointer" @click="toggleRowLot">
        <span v-if="lot.tax_dispositifs && lot.tax_dispositifs.length > 0" :title="lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData)">
          {{lot.tax_dispositifs | prettyTaxDispositifs(taxDispositifsData) | truncate}}
        </span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('profitability') && !isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.profitability">{{lot.profitability | prettyPrice}} %</span>
        <span v-else></span>
      </td>
      <td v-if="showColumn('capped_profitability') && !isParking" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.capped_profitability">{{lot.capped_profitability | prettyPrice}} %</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('date_livraison')" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.date_livraison">{{lot.date_livraison | prettyTrimestre}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('date_actabilite')" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.date_actabilite">{{lot.date_actabilite | checkActability}}</span>
        <span v-else>-</span>
      </td>
      <td v-if="showColumn('created_on') && isAdmin" @click="toggleRowLot" :class="{'has-cursor-pointer' : !rowIsParking}">
        <span v-if="lot.created_on">{{lot.created_on | date}}</span>
        <span v-else>-</span>
      </td>
      <td class="has-text-centered actions">
        <div v-if="isManager || isSeller">
          <button class="button is-circle is-small" @click.prevent.stop="addToWishlist(lot.pk)"
                  v-if="!isWishlisted(lot)">
            <i class="fal fa-star"></i>
          </button>
          <button class="button is-circle is-small" @click.prevent.stop="deleteFromWishlist(lot.pk)" v-else>
            <i class="fas fa-star"></i>
          </button>
        </div>
        <display-button-list v-else-if='!isParking'
                            :forceDropDown="true" :data="lot"
                            @hover="buttonListHover(lot)" :buttons="buttonListLot"
                            :openUp="{'position': index, 'total': total}">
        </display-button-list>
        <display-button-list v-else-if='isParking'
                            :forceDropDown="true" :data="lot"
                            @hover="buttonListHover(lot)" :buttons="buttonListParking"
                            :openUp="{'position': index, 'total': total}">
        </display-button-list>
      </td>
    </tr>
    <lot-row-detail :key="'lotrow-' + lot.pk" :id="'lotrow-' + lot.pk" v-if="isRowLotOpen && !isParking" @toggleRowLot="toggleRowLot"
                            :lot-row-pk="lot.pk" @loading="val => loadingRowLot = val" class="table-rowMoreInformations"></lot-row-detail>
  </tbody>
</template>

<script>
  import { DefaultValues, OptionStatus } from '@/mixins'
  import { mapGetters, mapState } from 'vuex'
  import { compact } from 'lodash'
  import LotRowDetail from '../lot/LotRowDetail'
  export default {
    name: 'LotRow',
    mixins: [DefaultValues, OptionStatus],
    components: { LotRowDetail },
    data () {
      return {
        myOptions: [],
        lotInfoPrograms: [],
        selectedLot: null,
        isRowLotOpen: false,
        loadingRowLot: false,
        buttonListLot: [
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'LotVue', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-file-invoice',
            text: 'Fiche lot'
          },
          {
            icon: 'fas fa-download',
            text: 'Télécharger le plan',
            action: (id) => {
              let selectedLot = this.items.find(x => x.pk === id)
              this.downloadFile(selectedLot.documents, selectedLot.ref, '.zip')
            },
            display: (lot) => {
              return lot.documents && lot.documents.length
            }
          },
          {
            icon: 'fas fa-flag',
            text: 'Poser option',
            action: (id) => {
              this.selectedLot = id
              this.$router.push({name: 'OptionCreate', query: {lot: id, returnId: id, page: this.currentPage}})
            },
            display: (lot) => {
              if (this.isOperator || this.isEditor) {
                return false
              }
              const option = this.runningOptions.find(o => o.lot === lot.pk)
              if (option && option.seller === this.currentUserPk && option.status === 'pending') {
                return false
              }
              const program = this.lotInfoPrograms.find(p => p.pk === lot.program)
              return program && this.canBeOptioned(lot.status, program)
            }
          },
          {
            icon: 'fa-star',
            text: 'Ajouter aux favoris',
            action: (id) => {
              this.selectedLot = id
              this.addToWishlist(this.selectedLot)
            },
            display: (lot) => {
              return !this.wishlists.find(w => w.lot === lot.pk)
            }
          },
          {
            icon: 'fas fa-star',
            text: 'Supprimer des favoris',
            action: (id) => {
              this.selectedLot = id
              this.deleteFromWishlist(this.selectedLot)
            },
            display: (lot) => {
              return this.wishlists.find(w => w.lot === lot.pk)
            }
          },
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'LotEdit', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-edit',
            text: 'Modifier fiche lot',
            needProfile: ['admin', 'editor'],
            display: (lot) => {
              return lot.nature !== 'parking'
            }
          },
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'ParkingEdit', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-edit',
            text: 'Modifier fiche lot',
            needProfile: ['admin', 'editor'],
            display: (lot) => {
              return lot.nature === 'parking'
            }
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fas fa-trash-alt',
            text: 'Supprimer lot',
            needProfile: ['admin']
          }
        ],
        buttonListParking: [
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'LotVue', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-file-invoice',
            text: 'Fiche parking'
          },
          {
            icon: 'fas fa-download',
            text: 'Télécharger le plan',
            action: (id) => {
              let selectedLot = this.items.find(x => x.pk === id)
              this.downloadFile(selectedLot.documents, selectedLot.ref, '.zip')
            },
            display: (lot) => {
              return lot.documents && lot.documents.length
            }
          },
          {
            icon: 'fas fa-flag',
            text: 'Poser option',
            action: (id) => {
              this.selectedLot = id
              this.$router.push({name: 'OptionCreate', query: {lot: id, returnId: id, page: this.currentPage}})
            },
            display: (lot) => {
              if (this.isOperator || this.isEditor) {
                return false
              }
              const option = this.runningOptions.find(o => o.lot === lot.pk)
              if (option && option.seller === this.currentUserPk && option.status === 'pending') {
                return false
              }
              const program = this.lotInfoPrograms.find(p => p.pk === lot.program)
              return program && this.canBeOptioned(lot.status, program)
            }
          },
          {
            icon: 'fa-star',
            text: 'Ajouter aux favoris',
            action: (id) => {
              this.selectedLot = id
              this.addToWishlist(this.selectedLot)
            },
            display: (lot) => {
              return !this.wishlists.find(w => w.lot === lot.pk)
            }
          },
          {
            icon: 'fas fa-star',
            text: 'Supprimer des favoris',
            action: (id) => {
              this.selectedLot = id
              this.deleteFromWishlist(this.selectedLot)
            },
            display: (lot) => {
              return this.wishlists.find(w => w.lot === lot.pk)
            }
          },
          {
            action: (id) => {
              let actionId = id
              this.$router.push({name: 'ParkingEdit', params: {id: actionId}, query: {returnId: actionId, page: this.currentPage}})
            },
            icon: 'fas fa-edit',
            text: 'Modifier fiche parking',
            needProfile: ['admin', 'editor']
          },
          {
            action: (id) => {
              this.deleteItem(id)
            },
            icon: 'fas fa-trash-alt',
            text: 'Supprimer parking',
            needProfile: ['admin']
          }
        ]
      }
    },
    props: {
      currentPage: Number,
      source: Object,
      isParking: Boolean,
      index: Number,
      columns: Array,
      multiselection: Boolean,
      total: Number,
      selectedItems: {
        type: Array,
        default: () => []
      }
    },
    filters: {
      prettyTaxDispositifs (values, data) {
        return compact(values.map(x => {
          if (x in data) {
            return data[x].short_label || data[x].label
          }
        })).join(', ')
      },
      checkActability (val) {
        let trim = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]]
        let date = new Date()
        let currentTrim = `${date.getFullYear()}${trim.findIndex(x => x.includes(date.getMonth())) + 1}`
        if (!val) {
          return 'NC'
        } else if (currentTrim > val) {
          return 'Oui'
        } else if (currentTrim <= val) {
          return 'Non'
        }
      }
    },
    computed: {
      ...mapState(['runningOptions', 'wishlists', 'configs']),
      ...mapGetters(['isDistributeurMode', 'isEditor', 'isManager', 'isSeller', 'isOperator', 'currentUserProfil', 'isExternal']),
      lot () {
        return this.source
      },
      rowIsParking () {
        return this.isParking || this.lot.nature === 'parking'
      }
    },
    methods: {
      showColumn (c) {
        return this.columns.includes(c)
      },
      addToWishlist (id) {
        this.$api.lotService.postWishlist({lot: id}).then(r => {
          this.$store.commit('addWishlist', {wishlist: r.data})
          this.$notify({
            type: 'is-success',
            text: 'Ajouté aux favoris.'
          })
        })
      },
      deleteFromWishlist (id) {
        let wishlist = this.wishlists.find(w => w.lot === id)
        this.$api.lotService.deleteWishlist(wishlist.pk).then(r => {
          this.$store.commit('removeWishlist', {wishlistPk: wishlist.pk})
          this.$notify({
            type: 'is-success',
            text: 'Supprimé de la liste des favoris'
          })
        })
      },
      deleteItem (id) {
        this.$emit('deleteItem', id)
      },
      toggleRowLot () {
        if (this.rowIsParking) return
        this.isRowLotOpen = !this.isRowLotOpen
        if (this.isRowLotOpen) {
          let container = '#list'
          this.$scrollTo(`#e${this.lot.pk}`, 400, {container})
        }
      },
      getMyOptions () {
        this.$api.optionService.get(this.currentUserPk).then(res => {
          this.myOptions = res.data
        }).catch(err => {
          console.log(err)
        })
      },
      canBeOptioned (lotStatus, program) {
        if (lotStatus && program) {
          const verifyOptions = this.myOptions.filter(x => x.pk === this.lot.pk)
          const okStatus = ['available', 'optioned']
          const programOkStatus = ['available', 'private']
          return programOkStatus.includes(program.status) && program.is_optionable && okStatus.includes(lotStatus) && !verifyOptions.length
        }
      },
      buttonListHover (lot) {
        const lotInList = this.lotInfoPrograms.find(p => {
          return p.pk === lot.program
        })
        if (!lotInList) {
          this.$api.programService.getOne(lot.program).then(r => {
            this.lotInfoPrograms.push(r.data)
            // this.$set(this, 'items', this.items)
          })
        }
      },
      isWishlisted (lot) {
        return this.wishlists.find(w => w.lot === lot.pk)
      },
      checkedItem (id) {
        return this.selectedItems.includes(id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/LotRow.vue